"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
/**
 * The `Currency` holds known currencies
 */
class Currency {
}
exports.Currency = Currency;
Currency.EUR = 'EUR';
//# sourceMappingURL=Price.js.map